import React from 'react';
import { SVGProps } from 'react';

const LightBulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="17"
    viewBox="0 0 13 17"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0605 0.706899C10.0864 0.577587 10.2157 0.5 10.345 0.5C10.4485 0.5 10.5778 0.577587 10.6036 0.706899L11.1726 2.15519L12.6208 2.72416C12.7501 2.75002 12.8277 2.87933 12.8277 2.98278C12.8277 3.1121 12.7501 3.24141 12.6208 3.26727L11.1726 3.81038L10.6036 5.28453C10.5778 5.38798 10.4485 5.46557 10.345 5.46557C10.2157 5.46557 10.0864 5.38798 10.0605 5.28453L9.51745 3.81038L8.04334 3.26727C7.91403 3.24141 7.8623 3.1121 7.8623 2.98278C7.8623 2.87933 7.91403 2.75002 8.04334 2.72416L9.51745 2.15519L10.0605 0.706899ZM2.48271 14.0173V15.0259C2.48271 15.1811 2.50857 15.3363 2.61202 15.4656L3.05167 16.138C3.18097 16.3449 3.49131 16.5001 3.74993 16.5001H5.32748C5.5861 16.5001 5.89644 16.3449 6.02575 16.138L6.46539 15.4656C6.54298 15.3621 6.5947 15.1552 6.5947 15.0259L6.62056 14.0173H2.48271ZM9.10327 7.81033C9.10327 5.30168 7.03435 3.25856 4.52577 3.28442C1.88789 3.28442 0 5.40513 0 7.81033C0 8.94827 0.413785 9.98277 1.11205 10.7845C1.55169 11.2759 2.19823 12.3104 2.45685 13.1638V13.1897H6.62056V13.1638C6.87918 12.3104 7.52572 11.2759 7.96536 10.7845C8.66363 10.0086 9.10327 8.97414 9.10327 7.81033ZM4.96542 5.35341C4.96542 5.58617 4.75853 5.76721 4.55164 5.76721C3.38787 5.76721 2.48271 6.67239 2.48271 7.81033C2.48271 8.04309 2.27582 8.22413 2.06893 8.22413C1.83617 8.22413 1.65514 8.04309 1.65514 7.81033C1.65514 6.23273 2.94822 4.93961 4.55164 4.93961C4.75853 4.93961 4.96542 5.14651 4.96542 5.35341Z"
    />
  </svg>
);

export default LightBulb;
